module.exports = __webpack_public_path__ + "cornerSprite-c6e1b8c26a4030a2b9e1a2fbe78fa184.png";